// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(rewardStatus) {
  switch (rewardStatus) {
    case "CLAIMED" :
        return /* Claimed */0;
    case "EXPIRED" :
        return /* Expired */2;
    case "UNCLAIMED" :
        return /* Unclaimed */1;
    default:
      return ErrorUtils$Catalyst.raiseError("RewardStatus.fromString", "Unexpected reward status", rewardStatus);
  }
}

export {
  fromString ,
  
}
/* No side effect */
